<template>
  <div class="home">
      <Navigation />
    <div class="section bg-primary-3">
      <div class="container text-center">
        <h1>Stock Photos</h1>
        <div class="text-large">Download and Post.</div>
      </div>
    </div>
    <div class="section bg-gray-4">
      <div class="container">
        <div class="w-layout-grid grid-quarters cards-grid">
          <Photo
            v-for="post in posts"
            :key="post.photo"
            :post="post"
            :showTitle="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import ContentService from "@/services/contentService.js";
import Photo from "@/components/Photo.vue";
export default {
  name: "home",
  components: {
    Navigation,
    Photo
  },
  data() {
    return {
      posts: []
    };
  },
  created()
  {
    ContentService.getPhotos()
      .then(response => {
        console.log(response.data.data);
        this.posts = response.data.data.stock_photos;
      })
      .catch(error => {
        console.log("There was an error getting the templates", error);
      });
  }
};
</script>
